module.exports = __webpack_public_path__ + "img/BILDE3.6a3dfb9c.jpg";